import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

export type Language = {
  en: boolean;
  de: boolean;
  fr: boolean;
  nl: boolean;
  sv: boolean;
  fi: boolean;
};

@Component({
  selector: 'email-referrals-logo',
  styleUrls: ['./email-referrals-logo.component.less'],
  template: `
    <ng-template #enReferralsLogo>
      <img
        class="logo-referrals"
        [src]="'assets/referrals.png'"
        [width]="243"
        [height]="59"
        alt="ReferralsHub"
      />
    </ng-template>

    <ng-container *mailgunIf="lang.en">
      <ng-container *ngTemplateOutlet="enReferralsLogo" />
    </ng-container>
    <ng-container *mailgunIf="lang.sv">
      <ng-container *ngTemplateOutlet="enReferralsLogo" />
    </ng-container>
    <ng-container *mailgunIf="lang.fi">
      <ng-container *ngTemplateOutlet="enReferralsLogo" />
    </ng-container>
    <img
      *mailgunIf="lang.de"
      class="logo-referrals logo-referrals-de"
      [src]="'assets/referrals-de.png'"
      [width]="343"
      [height]="60"
      alt=""
    />
    <img
      *mailgunIf="lang.fr"
      class="logo-referrals logo-referrals-fr"
      [src]="'assets/referrals-fr.png'"
      [width]="337"
      [height]="59"
      alt=""
    />
    <img
      *mailgunIf="lang.nl"
      class="logo-referrals"
      [src]="'assets/referrals.png'"
      [width]="243"
      [height]="59"
      alt="ReferralsHub"
    />
  `,
  imports: [EmailImageAssetDirective, EmailMailgunIfDirective, NgTemplateOutlet],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailReferralsLogoComponent {
  @Input({ required: true }) public lang: WrappedValue<Language>;
}
